import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Droplet, Fish, Sprout } from "lucide-react";

const ACCENTS = {
    lime: "var(--lime)",
    cyan: "var(--cyan)",
    coral: "var(--coral)",
};

export default function WeekCard({ week, index }) {
    const accent = ACCENTS[week.color] || "var(--lime)";
    const icon =
        week.week % 3 === 1 ? Droplet : week.week % 3 === 2 ? Fish : Sprout;
    const Icon = icon;
    return (
        <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
                delay: 0.05 * index,
                duration: 0.35,
                ease: "easeOut",
            }}
            className="card group p-6 md:p-7 min-h-[300px] flex flex-col justify-between"
            data-testid={`week-card-${week.id}`}
        >
            <span
                className="font-brush absolute -top-4 left-2 select-none pointer-events-none opacity-[0.06]"
                style={{ color: accent, fontSize: "11rem", lineHeight: 1 }}
                aria-hidden
            >
                W{week.week}
            </span>

            <div className="relative z-10 flex items-start justify-between">
                <div className="flex items-center gap-2">
                    <span
                        className="font-mono text-[10px] uppercase tracking-[0.22em] px-2 py-1 border"
                        style={{ borderColor: accent, color: accent }}
                    >
                        W//0{week.week}
                    </span>
                    <span className="font-mono text-[11px] text-[var(--muted)]">
                        {week.duration}
                    </span>
                </div>
                <Icon size={20} style={{ color: accent }} />
            </div>

            <div className="relative z-10 mt-6">
                <h3
                    className="font-display font-black text-white text-xl md:text-2xl leading-tight"
                    style={{ textShadow: "0 1px 0 #000" }}
                >
                    {week.title}
                </h3>
                <p className="font-mono text-sm text-[var(--muted)] mt-3 leading-relaxed">
                    {week.tagline}
                </p>
            </div>

            <Link
                to={`/curriculum/${week.id}`}
                data-testid={`week-open-${week.id}`}
                className="relative z-10 mt-6 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.18em] group-hover:gap-3 transition-all"
                style={{ color: accent }}
            >
                Enter Module <ArrowRight size={14} />
            </Link>
        </motion.div>
    );
}
